import type { AppDefinition } from '../types';

/** Alinma Bank — direct payout rails. No connector yet. */
export const ALINMA_APP: AppDefinition = {
  id: 'alinma',
  nameKey: 'apps.alinma.name',
  descriptionKey: 'apps.alinma.description',
  logo: '/images/apps/alinma-logo.svg',
  categories: ['banks'],
  status: 'soon',
  label: 'soon',
};
